const billingsKeys = {
  module: ['billings'] as const,
  list: () => [...billingsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) => [...billingsKeys.list(), filters] as const,
  details: (id: string) => [...billingsKeys.module, 'details', id] as const,
  occurrences: (id: string) =>
    [...billingsKeys.module, 'occurrences', id] as const,
};

export default billingsKeys;
